module.exports = __webpack_public_path__ + "static/media/logout_icon.2fce85e3.svg";